<div class="change-password">
  <div class="change-password-content">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <img
            alt="Alfresco, make business flow"
            src="./assets/images/alfresco-logo.svg"
          />
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <h2 class="title">{{ 'CHANGE_PASSWORD.TITLE' | translate }}</h2>
        <p>{{ 'CHANGE_PASSWORD.DESCRIPTION' | translate }}</p>
        <div
          class="error-container"
          *ngIf="failed || (submitted && formGroup.invalid)"
        >
          <mat-icon
            class="mat-icon notranslate material-icons mat-icon-no-color"
            aria-hidden="true"
            data-mat-icon-type="font"
          >
            warning
          </mat-icon>
          <div>
            <span
              *ngIf="
                formGroup.controls.password.errors?.required ||
                formGroup.controls.repeatPassword.errors?.required
              "
            >
              {{ 'CHANGE_PASSWORD.ERRORS.REQUIRED' | translate }}
            </span>
            <span
              *ngIf="
                formGroup.controls.password.errors?.PASSWORD_MIN_LENGTH_ERROR
              "
            >
              {{
                'CHANGE_PASSWORD.ERRORS.PASSWORD_MIN_LENGTH_ERROR' | translate
              }}
            </span>
            <span
              *ngIf="
                formGroup.controls.password.errors?.PASSWORD_MAX_LENGTH_ERROR
              "
            >
              {{
                'CHANGE_PASSWORD.ERRORS.PASSWORD_MAX_LENGTH_ERROR' | translate
              }}
            </span>
            <span
              *ngIf="
                formGroup.controls.repeatPassword.errors
                  ?.PASSWORDS_NOT_MATCH_ERROR
              "
            >
              {{
                'CHANGE_PASSWORD.ERRORS.PASSWORDS_NOT_MATCH_ERROR' | translate
              }}
            </span>
            <span
              *ngIf="
                formGroup.controls.password.errors?.PASSWORD_STRENGTH_ERROR
              "
            >
              {{ 'CHANGE_PASSWORD.ERRORS.PASSWORD_STRENGTH_ERROR' | translate }}
            </span>
            <span *ngIf="failed">
              {{ 'CHANGE_PASSWORD.ERROR_RESPONSES.' + failMessage | translate }}
            </span>
          </div>
        </div>
        <p class="success" *ngIf="success">
          {{ 'CHANGE_PASSWORD.SUCCESS' | translate }}
        </p>
        <form [formGroup]="formGroup" (submit)="onSubmit()">
          <mat-form-field>
            <input
              matInput
              type="password"
              autocomplete="off"
              formControlName="password"
              placeholder="{{
                'CHANGE_PASSWORD.FIRST_PLACEHOLDER' | translate
              }}"
            />
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              type="password"
              autocomplete="off"
              formControlName="repeatPassword"
              placeholder="{{
                'CHANGE_PASSWORD.SECOND_PLACEHOLDER' | translate
              }}"
            />
          </mat-form-field>
          <div class="submit">
            <button mat-raised-button color="accent" [disabled]="fetching">
              {{ 'CHANGE_PASSWORD.BUTTON' | translate }}
            </button>
          </div>
          <a
            class="return-to-login"
            [routerLink]="['/login']"
            [queryParams]="{ useSso: false }"
            >{{ 'APP.RETURN_TO_LOGIN' | translate }}</a
          >
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="copyright">
    {{ 'APP.COPYRIGHT' | translate }}
  </div>
</div>
